(ns manage.content-configuration-page.placeholder-expression.product-helper
  (:require ["@mui/material/Button$default" :as Button]
            [clojure.string :refer [blank?]]
            [common.ocp.view :refer [defocp ocp]]
            [common.widgets.dropdown :refer [dropdown]]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.input :refer [input]]
            [manage.content-configuration-page.context-source.products :as pcs]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [uix.core :as uix :refer [defui $]]
            [uix.re-frame :refer [use-subscribe]]))

;; database

(rf/reg-sub :ocp.product-helper/products-context-source-options
  :<- [:manage.content-configuration-page.context-source.db/context-sources]
  (fn [context-sources _]
    (for [{:context-source/keys [alias schema]} context-sources
          :when (= schema pcs/schema-id)]
      {:label alias :value alias})))

(rf/reg-sub :ocp.product-helper/product-property-options
  ;; Product item properties are retrieved from product schema.
  ;; which defines the available property fields for a product item.
  (fn [[_ context-source]]
    (rf/subscribe [:context-source/selector-schemas context-source [:items 0]]))
  (fn [{:keys [properties]} _]
    (for [[k {:keys [label]}] properties]
      {:label label :value (name k)})))

;; UI

(defui property-mapping
  [{{sph :db/id ph-name :placeholder/name} :sph
    pcs :pcs
    mappings :mappings
    on-change-mapping :on-change-mapping}]
  (let [[value set-value!] (uix/use-state nil)
        context-source (use-subscribe [:ui.store/pull-entity '[*] pcs])
        options (use-subscribe [:ocp.product-helper/product-property-options context-source])]
    ($ form-field
       {:label ph-name}
       (r/as-element
        [dropdown
         {:value value
          :on-change #(do (set-value! %) (on-change-mapping (assoc mappings sph (keyword %))))
          :options options}]))))

(defocp content-configuration-product-helper :content-configuration-product-helper
  {:width "40%"}
  [{{:collection-placeholder/keys [structure]} :collection-placeholder cphe :eid}]
  (let [[alias set-alias!] (uix/use-state (:value (first (use-subscribe [:ocp.product-helper/products-context-source-options]))))
        [mappings set-mappings!] (uix/use-state {})
        [n set-n!] (uix/use-state 1)]
    ($ ocp
       {:title "Product helper"
        :on-submit #(do (rf/dispatch [:collection-placeholder-expression/product-selector->collection-items
                                      cphe [:context-source/alias alias] n mappings])
                        (rf/dispatch [:ocp/close]))
        :footer ($ Button
                   {:type "submit"
                    :variant "contained"
                    :disabled (not= (count (keys mappings)) (count structure))}
                   "Add items")}

       ;; number of items
       ($ form-field
          {:label "Items to create"}
          ($ input
             {:type "number"
              :inputProps #js {:min 0}
              :placeholder "Enter number of items"
              :value n
              :onChange #(let [v (.. % -target -value)]
                           (set-n! (if (blank? v) 0 (js/parseInt v))))}))

       ;; product alias
       ($ form-field
          {:label "Product selector"}
          (r/as-element
           [dropdown
            {:options (use-subscribe [:ocp.product-helper/products-context-source-options])
             :value alias
             :on-change #(set-alias! %)}]))

       ;; mapping fields
       (doall (for [sph structure]
                ($ property-mapping {:key (:db/id sph)
                                     :sph sph
                                     :pcs [:context-source/alias alias]
                                     :mappings mappings
                                     :on-change-mapping set-mappings!}))))))
